import React from 'react';
import Rive from '@rive-app/react-canvas-lite';
import withStyles from '@material-ui/core/styles/withStyles';

import logoAnimation from './logo.riv';

const styles = {
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#3a465a',
  },
  loader: {
    width: 200,
    height: 200,
  },
};

const Preloader = ({ classes: cl }) => {

  return (
    <div className={cl.root}>
      <div className={cl.loader} role='progressbar'>
        <Rive src={logoAnimation} animations='loading' />
      </div>
    </div>
  );
};

export default withStyles(styles)(Preloader);
